module.exports = __webpack_public_path__ + "static/media/avatar2.a340f715.png";